$(document).ready(function () {
  $(".custom-collection-listing").slick({
    centerMode: true,
    // centerPadding: "420px",
    dots: false,
    arrows: true,
    slidesToShow: 1,
    autoplay: false,
    speed: 400,
    loop: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1 1 7l6 6" stroke="#050602" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1 1 6 6-6 6" stroke="#050602" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 1921,
        settings: {
          centerPadding: "300px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1387,
        settings: {
          centerPadding: "300px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1227,
        settings: {
          centerPadding: "230px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1027,
        settings: {
          centerPadding: "130px",
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerPadding: "60px",
        },
      },
    ],
  });

  //Responsive Footer Menu JS
  if($(window).width() < 992){
    $(".footer__menu .footer-block__heading").click(function () {
      $(this).next(".footer-block__details-content").slideToggle();
      $(this).toggleClass("active");
    });
  }

  // heritage product range page
  $("body").on("click", ".heritage-range-item", function (e) {
    e.preventDefault();
    var tab_id = $(this).attr("data-tab");
    $(this)
      .closest(".heritage-range-tab")
      .find(".heritage-range-item")
      .removeClass("active");
    $(this)
      .closest(".heritage-range-inner")
      .find(".heritage-range-tab-content ")
      .removeClass("active");
    $(this).addClass("active");
    $("#" + tab_id).addClass("active");
  });

  //press page logo slider
  function initializeSlider() {
    if ($("body").hasClass("page_press") && $(window).width() > 749 && !$(".press-logo-slider").hasClass("slick-initialized")) {
      $(".press-logo-slider").slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.65625 8.92969L7.14062 15.8047C7.29688 15.9349 7.45312 16 7.60938 16C7.79167 16 7.94792 15.9479 8.07812 15.8438C8.33854 15.5573 8.35156 15.2578 8.11719 14.9453L2.60938 9.125H17.3359C17.7526 9.07292 17.974 8.8776 18 8.53906C17.974 8.14844 17.7526 7.92708 17.3359 7.875H2.60938L8.11719 2.05469C8.35156 1.74219 8.33854 1.44271 8.07812 1.15625C7.76562 0.921875 7.45312 0.934896 7.14062 1.19531L0.65625 8.07031C0.447917 8.35677 0.447917 8.64323 0.65625 8.92969Z" fill="black"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next"><svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.3047 8.92969L11.8203 15.8047C11.6641 15.9349 11.5078 16 11.3516 16C11.1693 16 11.013 15.9479 10.8828 15.8438C10.6224 15.5573 10.6094 15.2578 10.8438 14.9453L16.3516 9.125H1.625C1.20833 9.07292 0.986979 8.8776 0.960938 8.53906C0.986979 8.14844 1.20833 7.92708 1.625 7.875H16.3516L10.8438 2.05469C10.6094 1.74219 10.6224 1.44271 10.8828 1.15625C11.1953 0.921875 11.5078 0.934896 11.8203 1.19531L18.3047 8.07031C18.513 8.35677 18.513 8.64323 18.3047 8.92969Z" fill="black"/></svg></button>',
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4,
            },
          }
        ]          
      });
    }
    else if ($(window).width() <= 749 && $('.press-logo-slider').hasClass('slick-initialized')) {
      $(".press-logo-slider").slick('unslick');
    }  
  }
  initializeSlider();
  $(window).on("resize", function() {        
    initializeSlider();
  });  
});
